module.exports = __webpack_public_path__ + "static/media/home_black.edc7d637.svg";